/*
==========================================================
IMPORTS
==========================================================
*/

import { Navigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";

import {
  isAdmin
} from "../../utils/authorization";

/*
==========================================================
COMPONENT
==========================================================
*/

export default function AdminRoute({

  children

}) {

  const {

    session

  } = useAuth();

  /*
  ==========================================================
  USER
  ==========================================================
  */

  const user = session?.user;

  /*
  ==========================================================
  AUTHORIZATION
  ==========================================================
  */

  if (

    isAdmin(user)

  ) {

    return children;

  }

  /*
  ==========================================================
  ACCESS DENIED
  ==========================================================
  */

  return (

    <Navigate

      to="/"

      replace

    />

  );

}